// extracted by mini-css-extract-plugin
export default {"bio":"Z3","about":"a4","title":"b4","text":"c4","fun_facts":"e4","fun":"f4","icon":"g4","bio_header":"h4"};
    if(module.hot) {
      // 1721922368429
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  